var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import { UiButton } from '@claims-ia/design-system';
import { QuestionComponent, QuestionProps } from '@declaration/question';
import RadioImageButton from '@declaration/components/UI/RadioImageButton.vue';
import QuestionPanel from '@declaration/components/UI/QuestionPanel.vue';
import { GLASS_BREAKAGE_DAMAGE_TYPE_ANSWERS, GLASS_BREAKAGE_DAMAGE_TYPE_IMAGE_CHOICES, GLASS_BREAKAGE_TRAD_KEYS, } from '@declaration/constants/glassBreakageDamageConstants';
import { GlassBreakageDamageType } from '@shared/types/api/glassBreakageDamage';
import { INSURER_CONFIG } from '@shared/insurer';
import { InsurerFeatureFlag, insurerHasFeature } from '@shared/featureFlags/insurerFeatureFlags';
const claim = namespace('claim');
const qualification = namespace('qualification');
let GlassBreakageDamageTypeQuestion = class GlassBreakageDamageTypeQuestion extends QuestionComponent {
    constructor() {
        super(...arguments);
        this.isSaving = false;
        this.typeOfDamages = '';
    }
    get typeTrigram() {
        var _a;
        return (_a = this.claimTypeTrigram) !== null && _a !== void 0 ? _a : undefined;
    }
    get hideHelpLink() {
        return insurerHasFeature(InsurerFeatureFlag.HideHelpLink, this.typeTrigram);
    }
    get showHelpLink() {
        var _a, _b;
        if (this.hideHelpLink &&
            ((_b = (_a = INSURER_CONFIG.declaration.pages) === null || _a === void 0 ? void 0 : _a.glassBreakageDamageType) === null || _b === void 0 ? void 0 : _b.showHelpLink) === false) {
            return false;
        }
        return true;
    }
    get panelTitle() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['damage-type-panel-title']);
    }
    get sidebarTitle() {
        const key = GLASS_BREAKAGE_TRAD_KEYS['damage-type-question-sidebar_title'];
        return this.$te(key) ? this.$tc(key) : this.panelTitle;
    }
    get questionDescription() {
        return this.$tc(GLASS_BREAKAGE_TRAD_KEYS['damage-type-question-description']);
    }
    get typeOfDamagesChoices() {
        return GLASS_BREAKAGE_DAMAGE_TYPE_IMAGE_CHOICES;
    }
    selectedValue() {
        if (this.qualification.hasRoomDamages && this.qualification.hasPersonalPropertyDamages) {
            return null;
        }
        if (this.qualification.hasRoomDamages) {
            return GlassBreakageDamageType.RoomDamages;
        }
        if (this.qualification.hasPersonalPropertyDamages) {
            return GlassBreakageDamageType.PersonalProperties;
        }
        return null;
    }
    get answer() {
        if (this.qualification.hasRoomDamages && this.qualification.hasPersonalPropertyDamages) {
            return this.$tc(GLASS_BREAKAGE_DAMAGE_TYPE_ANSWERS.both);
        }
        if (this.qualification.hasRoomDamages) {
            return this.$tc(GLASS_BREAKAGE_DAMAGE_TYPE_ANSWERS[GlassBreakageDamageType.RoomDamages]);
        }
        if (this.qualification.hasPersonalPropertyDamages) {
            return this.$tc(GLASS_BREAKAGE_DAMAGE_TYPE_ANSWERS[GlassBreakageDamageType.PersonalProperties]);
        }
        return null;
    }
    onTypeOfDamagesClick(typeOfDamages) {
        this.updateGlassBreakageDamageQualification({
            qualificationPayload: {
                hasRoomDamages: typeOfDamages === GlassBreakageDamageType.RoomDamages
                    ? !this.qualification.hasRoomDamages || this.qualification.hasPersonalPropertyDamages
                    : false,
                hasPersonalPropertyDamages: typeOfDamages === GlassBreakageDamageType.PersonalProperties
                    ? !this.qualification.hasPersonalPropertyDamages || this.qualification.hasRoomDamages
                    : false,
            },
        });
        this.$nextTick(() => {
            this.$forceUpdate();
        });
    }
    onBothButtonClick() {
        this.updateGlassBreakageDamageQualification({
            qualificationPayload: {
                hasRoomDamages: true,
                hasPersonalPropertyDamages: true,
            },
        });
        this.validate();
    }
    async validate() {
        await this.updateAndSaveGlassBreakageDamageQualification({
            qualificationPayload: {
                hasRoomDamages: this.qualification.hasRoomDamages,
                hasPersonalPropertyDamages: this.qualification.hasPersonalPropertyDamages,
            },
            step: this.step,
        });
    }
};
__decorate([
    claim.State('isUpdatingClaim')
], GlassBreakageDamageTypeQuestion.prototype, "isUpdatingClaim", void 0);
__decorate([
    claim.State('claimTypeTrigram')
], GlassBreakageDamageTypeQuestion.prototype, "claimTypeTrigram", void 0);
__decorate([
    qualification.State('qualification')
], GlassBreakageDamageTypeQuestion.prototype, "qualification", void 0);
__decorate([
    qualification.Action('updateQualification')
], GlassBreakageDamageTypeQuestion.prototype, "updateGlassBreakageDamageQualification", void 0);
__decorate([
    qualification.Action('updateAndSaveQualification')
], GlassBreakageDamageTypeQuestion.prototype, "updateAndSaveGlassBreakageDamageQualification", void 0);
GlassBreakageDamageTypeQuestion = __decorate([
    Component({
        components: { RadioImageButton, QuestionPanel, UiButton },
        props: QuestionProps,
    })
], GlassBreakageDamageTypeQuestion);
export default GlassBreakageDamageTypeQuestion;
